// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tXnf","col":"styles_col__4-sUP"};